import React from 'react';
import PropTypes from 'prop-types';
import ProjectCollabIllustration from 'images/ProjectCollabIllustration2021.png';
import ValuePropsModal from './ValuePropsModal';
import { FormattedMessage } from 'react-intl';

export default function ProjectCollaborationValuePropsModal({
  onRequestClose,
}) {
  const formattedTitle = (
    <FormattedMessage
      id="ValueProps.projectCollaboration.title"
      defaultMessage="Project Collaboration"
      description="Title to name Project Collaboration"
    />
  );

  const formattedDescription = (
    <FormattedMessage
      id="ValueProps.projectCollaboration.description"
      defaultMessage="Invite subcontractors or other companies to join your projects in CompanyCam."
      description="Description to explain Project Collaboration"
    />
  );

  const formattedChecklistItems = [
    <FormattedMessage
      id="ValueProps.projectCollaboration.valuePropA"
      defaultMessage="Instantly access their photos and videos"
      description="Value prop of Project Collaboration feature"
    />,
    <FormattedMessage
      id="ValueProps.projectCollaboration.valuePropB"
      defaultMessage="Include them in the project conversation"
      description="Value prop of Project Collaboration feature"
    />,
    <FormattedMessage
      id="ValueProps.projectCollaboration.valuePropC"
      defaultMessage="Add unlimited collaborators"
      description="Value prop of Project Collaboration feature"
    />,
  ];

  return (
    <ValuePropsModal
      title={formattedTitle}
      description={formattedDescription}
      checklistItems={formattedChecklistItems}
      image={ProjectCollabIllustration}
      isOpen
      onRequestClose={onRequestClose}
    />
  );
}

ProjectCollaborationValuePropsModal.propTypes = {
  onRequestClose: PropTypes.func,
};
